import React, { Component } from "react";

class ThreeD extends Component {
  render() {
    return (
      <div className=" mt-80px lg:pt-6 md:pt-6">
        <div className="container mx-auto">
          <iframe
            className="w-full"
            height="500"
            src="https://www.youtube.com/embed/L2Msk3quByc"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    );
  }
}
export default ThreeD;
